import {createSlice} from '@reduxjs/toolkit';
import {financeApi} from "../config";
import {serializeQuery} from "../utils";

const initialState = {
    ordered: [],
    hasMore: false,
};

export const slice = createSlice({
    name: 'payables',
    initialState,
    reducers: {
        setList: (state, action) => {
            const {ordered, hasMore} = action.payload;
            state.ordered = ordered;
            state.hasMore = hasMore;
        },
    }
});

// ACTIONS

const {setList} = slice.actions;

export const fetchReceived = (params) => async (dispatch, getState) => {
    const state = getState(), activeOrganizationId = state.client.realActiveCid
    await financeApi.get("/invoices/" + activeOrganizationId + "/received?" + serializeQuery(params)).then(({data}) => {
        //console.log("fetchInvoiceList", response.data)
        if (data?.results && data.results.length >= 0) {
            dispatch(setList({
                ordered: data.offset > 0 ? [...state.payables.ordered, ...data.results] : [...data.results],
                hasMore: data.hasMore
            }));
        } else {
            dispatch(setList({
                ordered: [],
                hasMore: false
            }));
        }
    }).catch(error => {
        console.log("error", error)
    })
}

// SELECTORS


export const payableListSelector = state => state.payables.ordered;
export const payableListHasMoreSelector = state => state.payables.hasMore;

export default slice.reducer;
